import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Checkbox } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { getDaysInYear, getWeeksInYear, getDateFromString } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import Combobox from '../Helper/Combobox';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import TarificationRecap from './Tarification/TarificationRecap';

class Tarification extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Tarification";
  }

  /**
  * goBackToElementContrat
  * Reload the ElementContrat
  **/
  goBackToElementContrat() {
    this.goBack();
    const idElementContrat = this.getObjectProperty("idElementContrat");
    this.props.history.replace(`/gpmg/elementcontrats/${idElementContrat}/edit`);
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.goBackToElementContrat.bind(this)} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de la tarification.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idTarification" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idTarification")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup>
            <Col sm={1} smOffset={2}><Checkbox name="estFacture" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("estFacture")} disabled={this.getReadOnly()}>Est facturé</Checkbox></Col>

            {/* <Col componentClass={ControlLabel} sm={1}>% Facturé</Col> */}
            {/* <Col sm={2}>
              <FormControl id="pourcentageFacture" ref="pourcentageFacture" type="number" step={0.000000000000000001} onChange={this.handleChange}
                min={0} max={100} value={this.getObjectProperty("pourcentageFacture")} placeholder="% Facturé" disabled={this.getReadOnly()} /></Col> */}
          </FormGroup>

          <FormGroup controlId="estSousLoue">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel></ControlLabel></Col>
            <Col sm={2}><Checkbox name="estSousLoue" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("estSousLoue")} disabled={this.getReadOnly()}>Est sous-loué</Checkbox></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Dimension</Col>
            <Col sm={2}><FormControl id="surface" type="number" step={0.01} onChange={this.handleChange} value={this.getObjectProperty("surface")} disabled={this.getReadOnly()} /></Col>
            <Col sm={1}><FormControl.Static>{this.getSubObjectProperty(["tarif", "unite", "titre"])}</FormControl.Static></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Tarif</Col>
            <Col sm={2}><Combobox ref="cbxTarif" url={REST_API_URL + "tarifs/valides"} optionValueKey="idTarif" optionLabelKey="libelle" searchable={true}
              default={this.getSubObjectProperty(["tarif", "idTarif"])} onChange={this.handleTarifSelect.bind(this)} placeholder="Tarif" disabled={this.getReadOnly()}
              customOptionTemplateFunction={this.tarifTemplateFn} /></Col>

            <Col sm={2}><FormControl type="text" value={this.getSubObjectProperty(["tarif", "valeur"])} disabled={true} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Remises</Col>

            <Col sm={2}>
              <FormControl id="remise1" ref="pourcentageFacture" type="number" step={0.000000000000000001} onChange={this.handleChange}
                min={0} max={100} value={this.getObjectProperty("remise1")} placeholder="Remise 1" disabled={this.getReadOnly()} /></Col>

            <Col sm={2}>
              <FormControl id="remise2" ref="pourcentageFacture" type="number" step={0.000000000000000001} onChange={this.handleChange}
                min={0} max={100} value={this.getObjectProperty("remise2")} placeholder="Remise 2" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="redevanceTheorique">
            <Col componentClass={ControlLabel} sm={2}>Redevance théorique</Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("redevanceTheorique")}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={true} />
            </Col>
          </FormGroup>

          {/* {this.getRecapTab()} */}
          <TarificationRecap object={this.state.object} />

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>

      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idTarification";
  }

  /**
  * tarifTemplateFn
  * Returns Tarif item style
  **/
  tarifTemplateFn(row, search) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dateValiditeDebut = row instanceof Object && row.dateValiditeDebut ? getDateFromString(row.dateValiditeDebut) : null;
    const dateValiditeFin = row instanceof Object && row.dateValiditeFin ? getDateFromString(row.dateValiditeFin) : null;

    return (!(row instanceof Object &&
           (!(dateValiditeDebut instanceof Date) || dateValiditeDebut <= today) &&
           (!(dateValiditeFin instanceof Date) || dateValiditeFin >= today))) ?
              <span key={row.idTarif} className="invalid">{row.libelle}</span> : row.libelle;
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    const method = "PUT";
    const path = REST_API_URL + this.getObjectPath();
    let tarificationObj = cloneObject(this.state.object);
    tarificationObj.total = this.getTotalAnnuel();

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(tarificationObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Tarification sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Tarification créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/tarifications/" + newObj[this.getIdField()] + "/edit", state);
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * handleTarifSelect
  * Handle tarif onChange event
  **/
  handleTarifSelect(tarif) {
    let objState = this.state;

    objState.object["idTarif"] = (tarif) ? tarif.idTarif : null;
    objState.object["tarif"] = tarif;

    this.setState(objState);
  }

  /**
  * getSousTotal
  * Returns Sous-total
  **/
  getSousTotal() {
    const tarif = this.getObjectProperty("tarif");
    let sousTotal = null;
    const surface = parseFloat(this.getObjectProperty("surface"));
    const tarifValeur = tarif ? parseFloat(tarif.valeur) : null;

    if(!isNaN(tarifValeur) && tarif.unite && tarif.unite.titre === "forfait") {
      sousTotal = tarifValeur;
    } else if(!isNaN(surface) && !isNaN(tarifValeur)) {
      sousTotal = surface * tarifValeur;
    }

  return Math.round(sousTotal * 100) / 100;
  }

  /**
  * getTotal
  * Returns total
  **/
  getTotal() {
    let total = this.getSousTotal();

    if(total !== null) {
      const remise1 = parseFloat(this.getObjectProperty("remise1"));
      const remise2 = parseFloat(this.getObjectProperty("remise2"));
      let remise1Valeur = 0, remise2Valeur = 0;

      if(!isNaN(remise1)) {
        remise1Valeur = total * (remise1 / 100);
      }

      if(!isNaN(remise2)) {
        remise2Valeur = total * (remise2 / 100);
      }

      total += - remise1Valeur - remise2Valeur;
    }

    return Math.round(total * 100) / 100;
  }

  /**
  * getTotalAnnuel
  * Returns total annuel
  **/
  getTotalAnnuel() {
    let total = this.getTotal();
    let ratio = 1;

    switch(this.getSubObjectProperty(["tarif", "uniteTemps", "libelle"])) {
      case "Jour":
        ratio = getDaysInYear();
        break;
      case "Semaine":
        ratio = getWeeksInYear();
        break;
      case "Mois":
        ratio = 12;
        break;
      default:
        break
    }

    return Math.round(total * ratio * 100) / 100;
  }

  /**
  * handleRedevanceTheoriqueChange
  * Handle redevance theorique change
  **/
  handleRedevanceTheoriqueChange(values) {
    let objState = this.state;
    objState.object["redevanceTheorique"] = values.value;
    this.setState(objState);
  }

}

export default Tarification;



// WEBPACK FOOTER //
// ./src/views/Entity/Tarification.js